import { render, staticRenderFns } from "./PremiumContent.vue?vue&type=template&id=44b85667&"
import script from "./PremiumContent.vue?vue&type=script&lang=js&"
export * from "./PremiumContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports